(() => {
  const lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  const SINGLE_FIELDS = ['relationship', 'recipient_age', 'familiarity', 'budget'];
  const GENERIC = ['all', 'any', 'general', 'universal', 'tous', 'toutes'];
  const ALIASES = {
    relationship: {
      colleague: ['colleague', 'collegue', 'coworker', 'co-worker', 'bureau', 'office'],
      boss: ['boss', 'manager', 'patron', 'chef', 'responsable'],
      friend: ['friend', 'friends', 'ami', 'amie'],
      family: ['family', 'famille', 'parent', 'parents', 'proche'],
      other: ['other', 'autre'],
    },
    recipient_age: {
      adult: ['adult', 'adulte', 'adults', 'adultes'],
      teen: ['teen', 'teens', 'teenager', 'teenagers', 'adolescent', 'adolescente', 'adolescents', 'adolescentes', 'ado', 'ados'],
      child: ['child', 'children', 'kid', 'kids', 'enfant', 'enfants'],
    },
    familiarity: {
      close: ['close', 'very-close', 'tres-bien', 'personal'],
      somewhat: ['somewhat', 'medium', 'un-peu', 'flexible'],
      barely: ['barely', 'little-known', 'a-peine', 'safe', 'low-risk'],
    },
    style: {
      funny: ['funny', 'drole', 'humor', 'humour'],
      useful: ['useful', 'utile', 'practical', 'pratique'],
      cute: ['cute', 'mignon', 'touching', 'touchant', 'cozy', 'emotional'],
      elegant: ['elegant', 'elegante', 'beautiful', 'beau', 'joli', 'design', 'premium'],
      original: ['original', 'originale', 'unusual', 'insolite', 'unique', 'surprising', 'quirky'],
      inspiring: ['inspiring', 'inspirant', 'motivational', 'motivation', 'self-development', 'personal-development', 'well-being', 'bien-etre'],
      safe: ['safe', 'passe-partout', 'low-risk', 'office-safe', 'broad-appeal'],
      personalized: ['personalized', 'personalised', 'personnalise', 'personnalisee', 'personnalisable'],
    },
    humor_level: {
      light: ['light', 'safe', 'sage', 'leger', 'gentle', 'soft'],
      playful: ['playful', 'medium', 'taquin', 'assume', 'bien-assume', 'fun'],
      bold: ['bold', 'very-bold', 'ose', 'tres-ose', 'edgy', 'roast-light', 'chaotic'],
    },
  };

  const LABELS = lang === 'es' ? {
    relationship: { colleague:'un compañero', boss:'tu jefe', friend:'un amigo o amiga', family:'un familiar', other:'otra persona', any:'cualquier relación' },
    recipient_age: { adult:'adulto', teen:'adolescente', child:'niño', any:'cualquier perfil' },
    familiarity: { close:'lo conoces muy bien', somewhat:'lo conoces un poco', barely:'apenas lo conoces', any:'cualquier grado de confianza' },
    budget: { under10:'menos de 10 €', '10-20':'10 a 20 €', '20-30':'20 a 30 €', '30-plus':'30 € o más', any:'presupuesto libre' },
    style: { funny:'divertido', useful:'útil', cute:'bonito o emotivo', elegant:'bonito o elegante', original:'original o insólito', inspiring:'inspirador', safe:'fácil de acertar', personalized:'personalizado', any:'cualquier estilo' },
    humor_level: { light:'humor ligero', playful:'humor marcado', bold:'humor muy atrevido', any:'cualquier nivel de humor' }
  } : lang === 'en' ? {
    relationship: { colleague:'a coworker', boss:'your boss', friend:'a friend', family:'a family member', other:'someone else', any:'any relationship' },
    recipient_age: { adult:'adult', teen:'teen', child:'child', any:'any profile' },
    familiarity: { close:'you know them very well', somewhat:'you know them a little', barely:'you barely know them', any:'any familiarity level' },
    budget: { under10:'under $10', '10-20':'$10 to $20', '20-30':'$20 to $30', '30-plus':'$30+', any:'open budget' },
    style: { funny:'funny', useful:'useful', cute:'cute or thoughtful', elegant:'stylish or elegant', original:'original or unusual', inspiring:'inspiring', safe:'safe choice', personalized:'personalized', any:'any style' },
    humor_level: { light:'light humor', playful:'playful humor', bold:'bold humor', any:'any humor level' }
  } : {
    relationship: { colleague:'un(e) collègue', boss:'votre boss', friend:'un ami / une amie', family:'un membre de la famille', other:'une autre personne', any:'peu importe la relation' },
    recipient_age: { adult:'adulte', teen:'adolescent(e)', child:'enfant', any:'peu importe le profil' },
    familiarity: { close:'vous la connaissez très bien', somewhat:'vous la connaissez un peu', barely:'vous la connaissez à peine', any:'peu importe le niveau de proximité' },
    budget: { under10:'moins de 10 €', '10-20':'10 à 20 €', '20-30':'20 à 30 €', '30-plus':'30 € et +', any:'budget libre' },
    style: { funny:'drôle', useful:'utile', cute:'mignon / touchant', elegant:'joli / élégant', original:'original / insolite', inspiring:'inspirant', safe:'passe-partout', personalized:'personnalisé', any:'peu importe le style' },
    humor_level: { light:'humour léger', playful:'humour bien assumé', bold:'humour très osé', any:'niveau d’humour libre' }
  };

  const RANGES = {
    under10: [0, 999],
    '10-20': [1000, 1999],
    '20-30': [2000, 2999],
    '30-plus': [3000, Infinity],
  };

  const ROLES = lang === 'es' ? {
    best:{label:'Mejor opción',icon:'🥇'}, safe:{label:'Elección segura',icon:'🛡️'}, original:{label:'La más original',icon:'🎁'}, budget:{label:'Mejor precio',icon:'💶'}, excellent:{label:'Excelente elección',icon:'⭐'}
  } : lang === 'en' ? {
    best:{label:'Best match',icon:'🥇'}, safe:{label:'Safe choice',icon:'🛡️'}, original:{label:'Most original',icon:'🎁'}, budget:{label:'Best value',icon:'💶'}, excellent:{label:'Excellent choice',icon:'⭐'}
  } : {
    best:{label:'Meilleur match',icon:'🥇'}, safe:{label:'Valeur sûre',icon:'🛡️'}, original:{label:'Le plus original',icon:'🎁'}, budget:{label:'Bon plan budget',icon:'💶'}, excellent:{label:'Excellent choix',icon:'⭐'}
  };

  const normalise = (value) => String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-');

  const asList = (value) => {
    if (Array.isArray(value)) return value.map(normalise).filter(Boolean);
    if (value == null || value === '') return [];
    if (typeof value === 'string' && value.trim().startsWith('[')) {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.map(normalise).filter(Boolean) : [normalise(parsed)];
      } catch (_) {}
    }
    return String(value).split(',').map(normalise).filter(Boolean);
  };

  const hasAny = (values, aliases) => {
    const haystack = asList(values);
    return aliases.some((alias) => haystack.includes(normalise(alias)));
  };

  const exact = (values, dimension, selected) => (
    selected !== 'any' && (
      hasAny(values, GENERIC) ||
      hasAny(values, ALIASES[dimension]?.[selected] || [])
    )
  );

  const truthy = (value) => value === true || value === 1 || value === '1' || normalise(value) === 'true';
  const falsey = (value) => value === false || value === 0 || value === '0' || normalise(value) === 'false';
  const clamp = (number, min, max) => Math.min(max, Math.max(min, number));
  const score10 = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? clamp(number, 0, 10) : 0;
  };

  const readAnswers = (source) => {
    const styles = (typeof source.getAll === 'function' ? source.getAll('style') : asList(source.get('style')))
      .map(normalise)
      .filter(Boolean);
    const humor = normalise(source.get('humor_level') || '');
    return {
      relationship: normalise(source.get('relationship') || ''),
      recipient_age: normalise(source.get('recipient_age') || ''),
      familiarity: normalise(source.get('familiarity') || ''),
      budget: normalise(source.get('budget') || ''),
      styles,
      humor_level: styles.includes('funny') ? (humor || 'any') : '',
    };
  };

  const complete = (answers) => SINGLE_FIELDS.every((key) => Boolean(answers[key])) && answers.styles.length > 0;

  const withinBudget = (product, budget) => {
    if (budget === 'any') return true;
    const range = RANGES[budget];
    const price = Number(product.price);
    return Boolean(range) && Number.isFinite(price) && price >= range[0] && price <= range[1];
  };

  const hardCompatible = (product, answers) => (
    Boolean(product) &&
    product.available !== false &&
    withinBudget(product, answers.budget) &&
    !(answers.recipient_age === 'child' && falsey(product.childSafe))
  );

  const styleMatch = (product, style) => (
    (style === 'personalized' && truthy(product.personalizable)) ||
    exact([product.style, product.quizTraits].flatMap(asList), 'style', style)
  );

  const desiredTraits = (answers) => {
    const traits = new Set();
    const add = (...values) => values.forEach((value) => traits.add(normalise(value)));
    if (answers.relationship === 'colleague') add('office-safe');
    if (answers.relationship === 'boss') add('office-safe', 'low-risk', 'premium-feel');
    if (answers.relationship === 'friend') add('conversation-starter');
    if (answers.relationship === 'family') add('emotional');
    if (answers.familiarity === 'barely') add('low-risk', 'office-safe');
    if (answers.familiarity === 'somewhat') add('flexible');
    if (answers.familiarity === 'close') add('personal', 'emotional');

    answers.styles.filter((style) => style !== 'any').forEach((style) => {
      if (style === 'funny') add('conversation-starter');
      if (style === 'useful') add('practical');
      if (style === 'cute') add('cozy', 'emotional');
      if (style === 'elegant') add('premium-feel', 'minimalist');
      if (style === 'original') add('quirky', 'conversation-starter');
      if (style === 'inspiring') add('motivational', 'creative', 'well-being');
      if (style === 'safe') add('low-risk', 'broad-appeal', 'office-safe');
      if (style === 'personalized') add('personal');
    });
    return [...traits];
  };

  const familiarityFraction = (product, selected) => {
    if (selected === 'any') return null;
    if (exact([product.familiarity, product.quizTraits].flatMap(asList), 'familiarity', selected)) return 1;
    const safety = score10(product.socialSafetyScore) / 10;
    const traits = asList(product.quizTraits);
    if (selected === 'barely') {
      if (hasAny(traits, ['safe', 'low-risk', 'office-safe', 'broad-appeal'])) return 1;
      return safety || 0;
    }
    if (selected === 'somewhat') {
      if (hasAny(traits, ['flexible', 'broad-appeal'])) return 1;
      return safety ? clamp(1 - Math.abs(safety - 0.7), 0, 1) : 0;
    }
    if (selected === 'close') {
      if (truthy(product.personalizable) || hasAny(traits, ['personal', 'emotional'])) return 1;
      return safety ? 0.45 + ((1 - safety) * 0.25) : 0;
    }
    return 0;
  };

  const styleFraction = (matchedCount, selectedCount) => {
    if (!selectedCount || !matchedCount) return 0;
    if (selectedCount === 1) return 1;
    return clamp(0.8 + (0.2 * ((matchedCount - 1) / Math.max(1, selectedCount - 1))), 0, 1);
  };

  const humorBonus = (product, answers) => {
    if (!answers.styles.includes('funny') || !answers.humor_level || answers.humor_level === 'any') return 0;
    if (!styleMatch(product, 'funny')) return 0;
    const levels = asList(product.humorLevel);
    if (!levels.length) return 1.5;
    if (exact(levels, 'humor_level', answers.humor_level)) return 5;
    return 0;
  };

  const scoreProduct = (product, answers) => {
    let earned = 0;
    let possible = 0;
    const detail = { matchedStyles: [], matchedTraits: [], humorBonus: 0 };

    if (answers.relationship !== 'any') {
      possible += 20;
      if (exact([product.relationship, product.quizTraits].flatMap(asList), 'relationship', answers.relationship)) earned += 20;
    }

    if (answers.recipient_age !== 'any') {
      possible += 10;
      if (exact([product.recipientAge, product.quizTraits].flatMap(asList), 'recipient_age', answers.recipient_age)) earned += 10;
    }

    if (answers.familiarity !== 'any') {
      possible += 20;
      earned += 20 * (familiarityFraction(product, answers.familiarity) || 0);
    }

    const styles = answers.styles.filter((style) => style !== 'any');
    if (styles.length) {
      possible += 35;
      detail.matchedStyles = styles.filter((style) => styleMatch(product, style));
      earned += 35 * styleFraction(detail.matchedStyles.length, styles.length);
    }

    const wantedTraits = desiredTraits(answers);
    if (wantedTraits.length) {
      possible += 15;
      const productTraits = asList(product.quizTraits);
      detail.matchedTraits = wantedTraits.filter((trait) => productTraits.includes(trait));
      const neededForFullCredit = Math.min(3, wantedTraits.length);
      earned += 15 * Math.min(1, detail.matchedTraits.length / neededForFullCredit);
    }

    const baseScore = possible ? (earned / possible) * 100 : 50;
    detail.humorBonus = humorBonus(product, answers);
    const score = clamp(baseScore + detail.humorBonus, 0, 100);
    return { product, score: Math.round(score * 10) / 10, detail };
  };

  const safeEligible = (item) => (
    score10(item.product.socialSafetyScore) >= 7 ||
    styleMatch(item.product, 'safe') ||
    hasAny(item.product.quizTraits, ['safe', 'low-risk', 'office-safe', 'broad-appeal'])
  );

  const originalEligible = (item) => (
    score10(item.product.originalityScore) >= 7 ||
    styleMatch(item.product, 'original') ||
    hasAny(item.product.quizTraits, ['quirky', 'unusual'])
  );

  const safetyEvidence = (item) => (
    score10(item.product.socialSafetyScore) +
    (styleMatch(item.product, 'safe') ? 4 : 0) +
    (hasAny(item.product.quizTraits, ['safe', 'low-risk', 'office-safe', 'broad-appeal']) ? 3 : 0) +
    (styleMatch(item.product, 'useful') ? 1 : 0)
  );

  const originalityEvidence = (item) => (
    score10(item.product.originalityScore) +
    (styleMatch(item.product, 'original') ? 4 : 0) +
    (hasAny(item.product.quizTraits, ['quirky', 'unusual', 'conversation-starter']) ? 2 : 0)
  );

  const first = (pool, predicate = () => true, sort = (a, b) => b.score - a.score) => (
    pool.filter(predicate).sort(sort)[0] || null
  );

  const stableHash = (value) => {
    let hash = 2166136261;
    for (const character of String(value)) {
      hash ^= character.charCodeAt(0);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  };

  const answerSignature = (answers) => [
    answers.relationship,
    answers.recipient_age,
    answers.familiarity,
    answers.budget,
    ...answers.styles,
    answers.humor_level,
  ].join('|');

  // Vary only exact score ties so equivalent products all remain discoverable
  // across valid quiz configurations without weakening relevance or budget rules.
  const tieRank = (product, answers) => stableHash(`${answerSignature(answers)}|${product.id}`);

  const recommend = (products, answers) => {
    const scored = products
      .filter((product) => hardCompatible(product, answers))
      .map((product) => scoreProduct(product, answers))
      .sort((a, b) => (
        b.score - a.score ||
        tieRank(a.product, answers) - tieRank(b.product, answers) ||
        Number(a.product.price) - Number(b.product.price)
      ));

    if (!scored.length) return [];

    const picks = [];
    const used = new Set();
    const remaining = () => scored.filter((item) => !used.has(String(item.product.id)));
    const take = (item, role) => {
      if (!item) return false;
      used.add(String(item.product.id));
      picks.push({ ...item, role });
      return true;
    };

    take(scored[0], 'best');
    const best = scored[0].score;
    const floor = Math.max(45, best * 0.65);

    const safe = first(
      remaining(),
      (item) => item.score >= floor && safeEligible(item),
      (a, b) => (safetyEvidence(b) * 5 + b.score) - (safetyEvidence(a) * 5 + a.score),
    );
    if (!take(safe, 'safe')) take(first(remaining()), 'excellent');

    const original = first(
      remaining(),
      (item) => item.score >= floor && originalEligible(item),
      (a, b) => (originalityEvidence(b) * 5 + b.score) - (originalityEvidence(a) * 5 + a.score),
    );
    if (!take(original, 'original')) take(first(remaining()), 'excellent');

    const budgetPool = remaining().filter((item) => item.score >= best * 0.70);
    const budget = first(
      budgetPool.length ? budgetPool : remaining(),
      () => true,
      (a, b) => Number(a.product.price) - Number(b.product.price) || b.score - a.score,
    );
    take(budget, 'budget');

    if (picks.length < 5) {
      const types = new Set(picks.map((item) => normalise(item.product.productType)).filter(Boolean));
      const diverse = first(
        remaining(),
        () => true,
        (a, b) => (
          (b.score - (types.has(normalise(b.product.productType)) ? 8 : 0)) -
          (a.score - (types.has(normalise(a.product.productType)) ? 8 : 0))
        ),
      );
      take(diverse, 'excellent');
    }

    while (picks.length < 5 && remaining().length) take(first(remaining()), 'excellent');
    return picks.slice(0, 5);
  };

  const join = (items) => {
    if (items.length < 2) return items[0] || '';
    const conjunction = lang === 'es' ? ' y ' : lang === 'en' ? ' and ' : ' et ';
    return `${items.slice(0, -1).join(', ')}${conjunction}${items.at(-1)}`;
  };

  const why = (item, answers) => {
    const product = item.product;
    const styles = item.detail.matchedStyles.map((style) => LABELS.style[style]).filter(Boolean);
    const facts = [];
    if (styles.length) facts.push(join(styles));
    if (answers.relationship !== 'any' && exact([product.relationship, product.quizTraits].flatMap(asList), 'relationship', answers.relationship)) {
      facts.push(lang === 'es' ? `adecuado para ${LABELS.relationship[answers.relationship]}` : lang === 'en' ? `suited to ${LABELS.relationship[answers.relationship]}` : `adapté à ${LABELS.relationship[answers.relationship]}`);
    }
    if (answers.budget !== 'any') facts.push(lang === 'es' ? 'dentro de tu presupuesto' : lang === 'en' ? 'within your budget' : 'dans votre budget');
    if (item.role === 'safe') return lang === 'es'
      ? (answers.familiarity === 'barely' ? 'Una opción fácil de regalar aunque apenas conozcas a la persona y coherente con tus criterios.' : 'Una opción segura y fácil de regalar, elegida entre los regalos que mejor encajan con tus criterios.')
      : lang === 'en' ? (answers.familiarity === 'barely' ? 'An easy gift even when you barely know the person, while still matching your criteria.' : 'A reassuring, easy-to-give option selected from the gifts that best match your criteria.')
      : (answers.familiarity === 'barely' ? 'Une option facile à offrir même si vous connaissez peu la personne, tout en restant cohérente avec vos critères.' : 'Une option rassurante et facile à offrir, sélectionnée parmi les cadeaux qui correspondent le mieux à vos critères.');
    if (item.role === 'original') return lang === 'es' ? 'Una opción más inesperada que las demás sin perder relevancia respecto a tus respuestas.' : lang === 'en' ? 'A more unexpected choice without sacrificing relevance to your answers.' : 'Un choix plus inattendu que les autres, sans sacrifier la pertinence par rapport à vos réponses.';
    if (item.role === 'budget') return lang === 'es' ? 'Una de las opciones más asequibles que mejor encajan con tus respuestas.' : lang === 'en' ? 'One of the most affordable options that still matches your answers well.' : 'Un très bon niveau de correspondance parmi les options les plus accessibles de votre budget.';
    return facts.length ? (lang === 'es' ? `¿Por qué esta opción? ${facts.join(' · ')}.` : lang === 'en' ? `Why this choice? ${facts.join(' · ')}.` : `Pourquoi ce choix ? ${facts.join(' · ')}.`) : (lang === 'es' ? 'Un excelente equilibrio entre los regalos compatibles con tus respuestas.' : lang === 'en' ? 'An excellent balance among the gifts compatible with your answers.' : 'Un excellent compromis parmi les cadeaux compatibles avec vos réponses.');
  };

  const summary = (answers) => {
    const parts = [];
    if (answers.relationship !== 'any') parts.push(LABELS.relationship[answers.relationship]);
    if (answers.recipient_age !== 'any') parts.push(LABELS.recipient_age[answers.recipient_age]);
    if (answers.familiarity !== 'any') parts.push(LABELS.familiarity[answers.familiarity]);
    if (answers.budget !== 'any') parts.push(LABELS.budget[answers.budget]);
    const styles = answers.styles.filter((style) => style !== 'any').map((style) => LABELS.style[style]);
    if (styles.length) parts.push(join(styles));
    if (answers.styles.includes('funny') && answers.humor_level && answers.humor_level !== 'any') {
      parts.push(LABELS.humor_level[answers.humor_level]);
    }
    return parts.length ? parts.join(' · ') : (lang === 'es' ? 'Nos das libertad total: estas son las opciones compatibles más interesantes.' : lang === 'en' ? 'You are giving us free rein: here are the most interesting compatible options.' : 'Vous nous laissez carte blanche : voici les options compatibles les plus intéressantes.');
  };

  const selectionUrl = (answers) => {
    const url = new URL(window.SecretSantaQuizLocalizedUrl || '/pages/quiz-cadeau-secret-santa', location.origin);
    SINGLE_FIELDS.forEach((key) => url.searchParams.set(key, answers[key]));
    url.searchParams.set('style', answers.styles.join(','));
    if (answers.styles.includes('funny') && answers.humor_level) url.searchParams.set('humor', answers.humor_level);
    return url.toString();
  };

  const fromParams = (params) => {
    const styles = asList(params.get('style'));
    return {
      relationship: normalise(params.get('relationship')),
      recipient_age: normalise(params.get('recipient_age') || params.get('profile')),
      familiarity: normalise(params.get('familiarity')),
      budget: normalise(params.get('budget')),
      styles,
      humor_level: styles.includes('funny') ? normalise(params.get('humor') || params.get('humor_level') || 'any') : '',
    };
  };

  window.SecretSantaQuizEngine = {
    SINGLE_FIELDS,
    LABELS,
    ROLES,
    normalise,
    asList,
    readAnswers,
    complete,
    recommend,
    why,
    summary,
    selectionUrl,
    fromParams,
  };

  const engineScript = document.currentScript;
  if (engineScript?.src && !document.querySelector('script[data-ss-humor-patch]')) {
    const patchUrl = new URL(engineScript.src);
    patchUrl.pathname = patchUrl.pathname.replace(/secret-santa-quiz-engine\.js$/, 'secret-santa-quiz-humor-patch.js');
    patchUrl.search = '';
    const patchScript = document.createElement('script');
    patchScript.src = patchUrl.toString();
    patchScript.defer = true;
    patchScript.dataset.ssHumorPatch = 'true';
    document.head.appendChild(patchScript);

    const fixUrl = new URL(patchUrl.toString());
    fixUrl.pathname = fixUrl.pathname.replace(/secret-santa-quiz-humor-patch\.js$/, 'secret-santa-quiz-humor-fix.js');
    const fixScript = document.createElement('script');
    fixScript.src = fixUrl.toString();
    fixScript.defer = true;
    fixScript.dataset.ssHumorFix = 'true';
    document.head.appendChild(fixScript);
  }
})();
